// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__dMGSN","title":"Card_title__GtrSy","message":"Card_message__YurD3","icon":"Card_icon__3v9mc"};